/**
 * Mappers for areas list operations
 */

import type {
  AreaListItem,
  AreasListResult,
  LC_CompanyAreaListItem,
  LC_GetCompanyAreasListOut,
} from '../types';

/**
 * Map single area list item from transport to domain model
 */
export function mapAreaListItemFromTransport(
  transport: LC_CompanyAreaListItem,
): AreaListItem {
  return {
    id: transport.areaId,
    code: transport.areaCode,
    name: transport.areaName,
    parentAreaId: transport.parentAreaId,
    parentAreaName: transport.parentAreaName,
    isEnabled: transport.isEnabled,
    createdDate: transport.createdDate,
    createdBy: transport.createdBy,
    modifiedDate: transport.modifiedDate,
    modifiedBy: transport.modifiedBy,
  };
}

/**
 * Map paginated areas list from transport to domain
 */
export function mapAreasListFromTransport(
  transport: LC_GetCompanyAreasListOut,
): AreasListResult {
  return {
    items: transport.data ? transport.data.map(mapAreaListItemFromTransport) : [],
    page: transport.pagination.currentPage,
    pageSize: transport.pagination.pageSize,
    totalRecords: transport.pagination.totalRecords,
    totalPages: transport.pagination.totalPages,
  };
}
